import { Wrench, DoorOpen, ShowerHead, Store, Frame, Droplets, ArrowRight } from "lucide-react";
import { DEFAULT_CONTENT } from "@/constants/siteDefaults";

const ICONS = [Wrench, DoorOpen, ShowerHead, Store, Frame, Droplets];

export default function Services({ content }) {
  const SERVICES = DEFAULT_CONTENT.services.map((d, i) => ({
    ...d,
    ...(content?.services?.[i] || {}),
    icon: ICONS[i],
    span: i === 0,
  }));
  return (
    <section id="services" className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-4">What we do</p>
        <h2 className="font-outfit text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-slate-800 max-w-2xl" data-testid="services-heading">
          Every job, big or small, done properly the first time.
        </h2>
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 border-t border-l border-slate-200">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className={`group border-b border-r border-slate-200 p-8 md:p-10 hover:bg-slate-50 transition-colors duration-300 ${s.span ? "md:col-span-2" : ""}`}
            >
              <s.icon size={28} strokeWidth={1.5} className="text-sky-500" />
              <h3 className="mt-5 font-outfit text-xl sm:text-2xl font-medium text-slate-800">{s.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-slate-600 max-w-md">{s.desc}</p>
              <a
                href="#contact"
                data-testid={`service-enquire-link-${i}`}
                className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 group-hover:text-sky-600 transition-colors duration-200"
              >
                Enquire about this <ArrowRight size={14} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
